<template>
  <el-dialog
    class="rc-dialog"
    :title="curdTitle"
    :visible.sync="CUFlag"
    v-if="CUFlag"
    @close="loseDialog"
    :close-on-click-modal="false"
  >
    <el-form
      ref="curdForm"
      size="small"
      :model="curdForm"
      :rules="rules"
      label-position="right"
      label-width="100px"
    >
      <el-row :gutter="12">
        <el-col>
          <el-form-item label="发布主体：" prop="publisherName" required>
            <el-input
              v-model="curdForm.publisherName"
              placeholder="请输入发布主体"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            class="scale"
            label="配图："
            prop="iconUrl"
            :rules="{
              required: true,
              message: '请上传图片'
            }"
            :show-message="showError"
          >
            <div
              v-if="curdForm.iconUrl"
              id="video-output"
              @mouseenter="showCover = true"
              @mouseleave="showCover = false"
            >
              <img :src="curdForm.iconUrl" class="avatar" />
              <div v-show="showCover" class="cover-bg">
                <i
                  class="el-icon-zoom-in delete"
                  @click.stop="showViewer = true"
                ></i>
                <i class="el-icon-delete delete" @click.stop="deleteCover"></i>
              </div>
            </div>
            <el-upload
              v-else
              action=""
              class="avatar-uploader"
              :show-file-list="false"
              :http-request="uploadCover"
              accept="png,jpg,jpeg"
              :limit="1"
              ref="coverUpload"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <label v-if="!curdForm.iconUrl" class="upload-text"
                >上传图片</label
              >
            </el-upload>
            <div class="upload_tip" v-if="curdForm.displayClientType == 1">
              <p class="img_tip">建议尺寸：1080px*360px（或3:1）</p>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="是否上线：" prop="onlineStatus" required>
            <el-radio-group v-model="curdForm.onlineStatus">
              <el-radio
                v-for="(item, i) in onlineStatusList"
                :key="i"
                :label="item.paramKey"
                >{{ item.paramValue }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-image-viewer
      v-if="showViewer"
      :on-close="closeViewer"
      :url-list="[curdForm.iconUrl]"
    />
    <div slot="footer" class="dialog-footer">
      <butn @click.native="closeFrom('curdForm')" btntype title="取消"></butn>
      <butn btntype="primary" @click.native="createData()" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import Bus from "./Bus";
import FileHandler from "@/utils/file";
import rulesFactory from "@/utils/rules";
import { publisherAdd, publisherEdit } from "@/api/shortVideoPublisher";
import { getDataMap } from "@/api/sysParam";
import vue from "@/main";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
export default {
  components: { butn, ElImageViewer },
  data() {
    return {
      Bus,
      rules: {
        publisherName: [
          rulesFactory.required("请填写发布主体"),
          rulesFactory.size("最多输入50个字", 0, 50)
        ],
        onlineStatus: [rulesFactory.required("请选择上线状态")]
      },
      curdTitle: "",
      CUFlag: false,
      Dflag: false,
      curdForm: {},
      defaultCheckedKeys: [],
      command: function() {},
      onlineStatusList: [],
      showError: false,
      showCover: false,
      showViewer: false
    };
  },
  created() {
    var _this = this;
    _this.getSysParam("ONLINE_STATUS");
    Bus.$on("ReceiveMessage", function(item) {
      _this.$nextTick(() => {
        _this.curdTitle = item == "" ? "新增发布主体" : "编辑发布主体";
        _this.command = item == "" ? publisherAdd : publisherEdit;
        _this.CUFlag = true;
        _this.curdForm = item || {
          publisherName: "",
          iconUrl: "",
          onlineStatus: "0"
        };
        _this.curdForm.onlineStatus = _this.curdForm.onlineStatus + "";
        if (item === "123") {
          _this.CUFlag = false;
        }
      });
    });
  },
  methods: {
    // 获取数据字典
    getSysParam(param) {
      getDataMap(param).then(res => {
        if (!res || res.code != 0) return;
        if (param == "ONLINE_STATUS") {
          this.onlineStatusList = res.data;
          // 设置默认选中
          this.curdForm.onlineStatus = res.data[0].paramKey;
          return;
        }
      });
    },
    async uploadCover(e) {
      let file = e.file;
      // 校验文件格式是否符合要求(png格式或者jpg格式)
      const image = await FileHandler.isImage(file);
      if (!image) {
        this.$message({
          message: "请上传格式为png、jpg格式的文件，其余文件格式无法上传哦！",
          type: "warning"
        });
        // 重点: 异常流程时必须要清除上传的文件，否则设置限制文件上传数量为1时不能再次执行上传事件
        this.$refs["coverUpload"].clearFiles();
        return;
      }
      FileHandler.uploadFile(`shortVideoPublisher/img`, file).then(res => {
        const { url } = res;
        this.curdForm.iconUrl = url;
      });
    },
    closeViewer() {
      this.showViewer = false;
    },
    deleteCover() {
      if (this.$refs["coverUpload"] !== undefined) {
        this.$refs["coverUpload"].clearFiles();
      }
      this.curdForm.iconUrl = "";
    },
    createData() {
      this.$refs.curdForm.validate(valid => {
        if (valid) {
          this.loading = true;
          this.curdForm.uuid = this.curdForm.uuid || "";
          const params = Object.assign({}, this.curdForm);
          this.command(params).then(res => {
            this.loading = false;
            if (res && res.code == 0) {
              this.$message.success(res.msg);
              vue.$emit("reload");
              this.CUFlag = false;
            }
          });
        }
      });
    },
    closeFrom(curdForm) {
      this.CUFlag = false;
      // 点击取消 数据重置
      this.$refs[curdForm].resetFields();
    },
    loseDialog() {
      // 点击取消 数据重置
      this.$refs["curdForm"].resetFields();
    }
  }
};
</script>

<style lang="scss" scoped>
$textColor: #51627d;
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  background-color: #f7f9fc;
  width: 320px;
  height: 160px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 70px;
  height: 70px;
  line-height: 70px;
  text-align: center;
}

.avatar {
  width: 320px;
  height: 160px;
  display: block;
  object-fit: contain;
}

.upload-text {
  color: $textColor;
  font-size: 13px;
}

#video-output {
  width: 320px;
  height: 160px;
  position: relative;

  .cover-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(1, 1, 1, 0.5);
    z-index: 199;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    color: #ffffff;

    .delete {
      font-size: 20px;
      cursor: pointer;
    }
  }
}

.upload_tip {
  width: 320px;
  text-align: center;
  margin-top: 10px;
}

.upload_tip p {
  font-size: 14px;
  margin: 0;
  line-height: 30px;
  color: #51627d;
}

.upload_tip p.img_tip {
  font-size: 12px;
  color: #96a1b2;
}

.autocomplete {
  width: 100%;
}

.el-autocomplete-suggestion {
  display: none;
}
</style>
